import { useNavigate } from "react-router-dom";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import AddCarCardIconSVG from "../../assets/icons/svg/AddCarCardIconSVG";

const AddCarButtonCard = () => {
    const navigate = useNavigate();

    return (
        <div
            style={styles.mainContainer}
            onClick={() => navigate('/add-user-car')}
        >

            <div style={styles.bodyContainer}>
                <div style={styles.iconContainer}>
                    <AddCarCardIconSVG />
                </div>


                <div style={styles.textContainer}>
                    <p style={styles.parkText}>
                        Parkiraj vozilo u garažu
                    </p>

                    <p style={styles.descText}>
                        Uštedi vreme kod svake sledeće pretrage delova.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default AddCarButtonCard;


const styles = {
    mainContainer: {
        cursor: "pointer",
        paddingTop: 50,
        paddingInline: 20,
        paddingBottom: 20,
        backgroundColor: "rgb(245, 245, 244)",
        border: "2px solid rgb(91, 33, 182)",
        borderRadius: 6,
        width: "300px",
        height: "300px"
    },
    bodyContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    textContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 8
    },
    parkText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        color: "rgb(91, 33, 182)",
        fontWeight: 700
    },
    descText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        color: "rgba(0, 0, 0, 0.6)",
        fontWeight: 400
    }
};